<template>
  <b-container fluid>
    <div v-if="!showAuditDetail">
      <b-row cols="1" cols-md="2">
        <b-col>
          <b-container class="contentcontainer site-detail__auditdashboard">
            <b-row class="contentcontainer__head">
              <b-col>
                <h2>{{$t('site.startnewaudit')}}</h2>
              </b-col>
            </b-row>
            <hr/>
            <b-row>
              <b-col>
                <p v-html="$t('site.startnewauditmessage')"></p>
                <button class="btn btn--primary" v-on:click="startAudit">{{$t('site.startnewaudit')}}</button>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
        <b-col>
          <b-container class="contentcontainer site-detail__auditdashboard">
            <b-row class="contentcontainer__head">
              <b-col>
                <h2>{{$t('site.aboutaudits')}}</h2>
              </b-col>
            </b-row>
            <hr/>
            <b-row>
              <b-col>
                <p v-html="$t('site.aboutauditsmessage')"></p>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <audits-section
            v-bind:show-full-list-link="false"
            v-bind:show-back-link="true"
            v-bind:show-pagination="true"
            v-bind:limit="20"
            v-on:close-detail="closeSiteDetailPageBackups"
          >
          </audits-section>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <the-audit />
    </div>
  </b-container>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'

import AuditsSection from './AuditsSection'
import TheAudit from '../Audits/TheAudit'

export default {
  name: 'SiteDetailAuditdashboard',

  components: {
    AuditsSection,
    TheAudit
  },

  computed: {
    ...mapState('site', [
      'siteDetail'
    ]),

    ...mapState('audit', [
      'showAuditDetail'
    ])
  },

  methods: {
    ...mapMutations('site', [
      'closeSiteDetailPageBackups'
    ]),

    ...mapMutations('common', [
      'startLoading',
      'endLoading'
    ]),

    ...mapActions('backup', [
      'backupAndAudit'
    ]),

    startAudit () {
      if (!this.isLoading) {
        this.startLoading()
      }

      this.backupAndAudit(this.siteDetail.data.id).then(
        response => {
          this.endLoading()
        }
      )
    }
  }
}

</script>
